import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
// import { CanonicalService } from 'src/app/shared/canonical.service';
import { CanonicalService } from '../../shared/canonical.service';

@Component({
  selector: 'app-android',
  templateUrl: './android.component.html',
  styleUrls: ['./android.component.css']
})
export class AndroidComponent implements OnInit {

  heading = "Best for Android Mobile Device Security";
  subheading = "Your personal data is everywhere.";
  innerWidth:number = window.innerWidth;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private metaTagService1: Meta,
    private canonicalService: CanonicalService
    ) { 
      this.canonicalService.setCanonicalURL("https://www.protectt.ai/mprotectt/android");
    }

  ngOnInit(): void {
    // this.canonicalService.setCanonicalURL();
    setTimeout(() => {
      AOS.refresh();
    }, 500);
    this.titleService.setTitle('Android Mobile Security | Mobile Antivirus | Protectt.ai');
    this.metaTagService1.updateTag({name: 'title', content: 'Mobile App Security Protection for Android Mobile Device | Protectt.ai'});
    this.metaTagService.addTags([
      {name: 'description', content:'We offer the most secure and advanced mobile security app for Android. We used the latest technology to detect fraud, safeguarding the app from online banking fraud. Download now the most secure mobile security banking app.'},
      {name: 'keywords', content:'MProtectt, Mobile Antivirus, Android Security, Mobile Security',},
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'mprotectt.protectt.ai' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'date', content: '01-06-2021', scheme: 'DD-MM-YYYY' },
      { charset: 'UTF-8' },
    ]);
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
